// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3Qaax","column":"style_column__3f9zG","row":"style_row__g7WiS"};